var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-header',{ref:"theHeader"}),_vm._m(0),_c('the-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paperform-wrapper"},[_c('div',{attrs:{"data-paperform-id":"6wloiz3f"}})])
}]

export { render, staticRenderFns }